export const getDefaultTimezoneByCountry = (country: string): string => {
  switch (country.toLowerCase()) {
    case 'id':
      return 'Asia/Jakarta';
    case 'kr':
      return 'Asia/Seoul';
    case 'jp':
      return 'Asia/Tokyo';
    case 'fr':
      return 'Europe/Paris';
    default:
      return 'UTC';
  }
};
